import {useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface IssueCategory {
  id: number;
  name: string;
}

export interface CategoryHelpText {
  question?: string | null;
  help_text: string;
  deflectable: boolean;
  link_url?: string | null;
  link_label?: string | null;
}

export interface IssueCategoriesResponse {
  status: string;
  data: IssueCategory[];
  help_text?: Record<string, CategoryHelpText[]>;
  // Ticket reply SLA in minutes, keyed by the same sub-category id.
  comm_sla_minutes?: Record<string, number>;
  // How fast "Chat with us" replies, in minutes.
  chat_reply_minutes?: number;
}

export default function useGetIssueCategories(
  handleOnSuccess?: (data: IssueCategoriesResponse) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation<IssueCategoriesResponse>({
    mutationFn: async () => {
      const response = await ChessRestClient.get(
        '/user_raised_issues/categories',
      );
      return response.data;
    },
    onSuccess: data => {
      if (handleOnSuccess) {
        handleOnSuccess(data);
      }
    },
    onError: error => {
      if (handleOnError) {
        handleOnError(error);
      }
    },
  });

  return mutation;
}
